import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Progress ({
  show = true,
  style = {},
  ...props
}) {
  if (!show) return null;
  return (
    <Box sx={{
      zIndex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      background: 'white',
      ...style
    }}>
      <CircularProgress {...props} />
    </Box>
  );
}